import SxSViewState, { RightPaneDisplay } from '../store/schema/SxSViewState';
import { PreviewPaneMode } from '../store/schema/PreviewPaneViewState';

export default function getInitialSxSViewState(): SxSViewState {
    return {
        previewPane: {
            downloadUrl: null,
            mode: PreviewPaneMode.Blank,
        },
        hideRightPane: false,
        rightPaneSize: 0,
        leftPaneSizePixels: 0,
        rightPaneSizePixels: 0,
        rightPaneDisplay: RightPaneDisplay.Initial,
    };
}
